function SpinnerLoader() {
  return (
    <div className="px-spinner-wrap">
        <div className="px-spinner"></div>
    </div>
  );
}

export default SpinnerLoader;